import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/yzm'
    },
    {
      path: '/yzm',
      name: 'yzm',
      component: () => import( './views/yzm.vue')
    },
    {
      path: '/a1',
      name: 'a1',
      component: () => import( './views/a1.vue')
    },
    {
      path: '/a2',
      name: 'a2',
      component: () => import( './views/a2.vue')
    },
    {
      path: '/a3',
      name: 'a3',
      component: () => import( './views/a3.vue')
    },
    {
      path: '/a4',
      name: 'a4',
      component: () => import( './views/a4.vue')
    },
    {
      path: '/a5',
      name: 'a5',
      component: () => import( './views/a5.vue')
    },
    {
      path: '/a6',
      name: 'a6',
      component: () => import( './views/a6.vue')
    }
  ]
});
